import Vue from 'vue'
import router from './router'
import { constantRouterMap } from "@/config/router.config"
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN,INDEX_MAIN_PAGE_PATH } from '@/store/mutation-types'
import { generateIndexRouter } from "@/utils/util"

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/user/register', '/user/register-result','/user/alteration'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar

  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next()
      NProgress.done()
    } else {
      if (store.getters.permissionList.length === 0) {
        store.dispatch('user/GetPermissionList').then(res => {
              const menuData = res.result.menu;
              //console.log(res.message)
              if (menuData === null || menuData === "" || menuData === undefined) {
                return;
              }
              let constRoutes = [];
              constRoutes = generateIndexRouter(menuData);
			        let  roles=JSON.parse(localStorage.getItem('role'));
			 
              // 添加主界面路由
              store.dispatch('GenerateRoutes', roles).then((accessRoutes) => {
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
               router.options.routes = constantRouterMap.concat(accessRoutes)
               router.addRoutes(accessRoutes)
                const redirect = decodeURIComponent(from.query.redirect || to.path)
                 next({ path: redirect })
                if (to.path === redirect) {
                  // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                  next({ ...to, replace: true })
                } else {
                  // 跳转到目的路由
                  next({ path: redirect })
                }
              })
            })
          .catch(() => {
           /* notification.error({
              message: '系统提示',
              description: '请求用户信息失败，请重试！'
            })*/
            store.dispatch('user/Logout').then(() => {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      const query = { redirect: to.fullPath }
      // 透传第三方免密登录的 code 参数到登录页
      if (to.query && to.query.code) {
        query.code = to.query.code
      }
      next({ path: '/user/login', query })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
